// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { FontWeight, Colors } from '../../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.5,
  },
  toggleOffTextWrapper: {
    position: 'absolute',
    padding: '48px 45px',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, 0)',
    width: 638,
    border: '1px solid rgba(148,148,148,0.28)',
    backgroundColor: Colors.White,
  },
  toggleOffText: {
    fontSize: 25,
    color: Colors.Blue,
    fontWeight: FontWeight.Bold,
    textAlign: 'center',
  },
  buttonWrapper: {
    textAlign: 'end',
    marginTop: 50,
  },
  button: {
  '&.MuiButton-root':{
    width: 180,
    maxWidth: 180,
    marginLeft: 10,
  }
  },
  secondaryButton: {
    textTransform: 'none',
  },
  homeBtn: {
    padding: '8px 12px !important',
    color: `${Colors.Blue1} !important`,
    fontSize: '15px !important',
    lineHeight: '15px !important',
    borderRadius: '4px !important',
    float: 'left',
    '& svg': {
      transform: 'scale(-1, 1)',
      marginRight: '6px',
    },
  },
}));

export default useStyles;
